// Event-only window bits (resize/drag icons); the frame box lives in WindowFrame.css.
import styled from 'styled-components';
import {BGImageCenter, mobileMedia} from '../../../../globalVariables/GlobalVariables';
import {op, opWhite, dragPoints} from '../../../../assets/symbols/symbols/Symbols.css';

// The frame box moved to WindowFrame.css; re-exported here so existing consumers
// (e.g. EventRealtime.css) keep importing `windowWrapper` from window.css unchanged.
export {windowWrapper} from '../windowFrame/WindowFrame.css';

export const layoutIcon = styled.div`

  .Button.free-color {
    border: none;
  }
    ${mobileMedia}{
        margin-inline-end: 15px;
    }
`;
export const moreActionsIcon = styled.div`
  ${p=>BGImageCenter(p.theme.isDarkMode?opWhite:op, '10px')}
    width: 8px;
    height: 16px;
    cursor: pointer;
    &.disabled{
        opacity: 0.6;
        cursor: unset;
        pointer-events:none;
    }

`;
export const dragIcon = styled.div`
  ${p=>BGImageCenter(p.theme.isDarkMode?dragPoints:dragPoints, '24px')}
    width: 11px;
    height: 16px;
    cursor: pointer;

`;
